import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import HAFHQRScanner from "./HAFHQRScanner";

const capturePoints = [
  "main_gate",
  "mess",
  "room",
  "indoor_activity",
  "outdoor_atctivity",
  "offsite",
  "transit",
];

const HAFHAttendanceCapture = ({ student, t, mode, isUpdateRecord, isUpdateTimeOut }) => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();
  const [showQR, setShowQR] = useState(false);

  const userId = authState?.user?._id;
  const userName = authState?.user?.name;
  const [isSaving, setIsSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [capturePoint, setCapturePoint] = useState(student?.capturePoint || "");
  const [attendanceMode, setAttendanceMode] = useState(mode || "IN");
  const [remarks, setRemarks] = useState(student?.capture_remarks || "");
  const [deviceLocation, setDeviceLocation] = useState(null);
  const [isGeneralAttendance, setIsGeneralAttendance] = useState(false);
  const [saveMessage, setSaveMessage] = useState("");

  const isCaptureDisabled =!capturePoint || !attendanceMode ;

  const getDeviceTime = () => {
    const now = new Date();
    return now.toTimeString().slice(0, 5); 
  };

  const getDeviceDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  const handleGeneralAttendance = () => {
    setIsGeneralAttendance(true);
    setShowQR(false);
    setDeviceLocation();
  }; 

  const handleLocationCapture = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported");
      return;
    }

    navigator.geolocation.getCurrentPosition((pos) => {
      setDeviceLocation({
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      });
    });
  };

  /* ================= QR RESULT ================= */
  const handleQRScan = (data) => {
    setShowQR(false);

    // assuming QR contains capturePoint or student validation
    setCapturePoint(data);
  };

  const handleCaptureAttendance = async () => {
    const timeNow = new Date().toTimeString().slice(0, 5);
    const dateNow = new Date().toISOString().split("T")[0];

    const payload = {
      capturePoint,
      capture_remarks: remarks,
      capture_lat_in: deviceLocation?.lat,
      capture_long_in: deviceLocation?.lng,
    };

    try {
      let config;

      if (attendanceMode === "OUT" || isUpdateRecord ) {
        const updatePayload = {
          ...payload,
          ...(isUpdateTimeOut
            ? {
                out_time: timeNow,
                capture_lat_out: deviceLocation?.lat,
                capture_long_out: deviceLocation?.lng,
              }
            : {}),
        };
        config = {
          url: `/hafh/core/attendance/${student._id}`,
          method: "put",
          data: updatePayload,
          headers: {
            Authorization: authState.token,
          },
        };
      } else {
        config = {
          url: "/hafh/core/attendance/create",
          method: "post",
          data: {
            ...payload,
            userId,
            userCode: authState?.user?.think5whyscode,
            hostelStudentCode: student?.hostelStudentCode,
            hostelCode: student?.hostelCode,
            hostelName: student?.hostelName,
            roomNo: student?.roomNo,
            dateAttendance: dateNow,
            in_time: timeNow,
            capture_method: "MOBILE_APP",
          },
          headers: {
            Authorization: authState.token,
          },
        };
      }

      // const res = await fetchData(config);
      const res = await fetchData(config, {
        showSuccessToast: false,
      });
      if (res?.status) {
          setSaveSuccess(true);

          setSaveMessage(
            attendanceMode === "UPDATE"
              ? "✅ Attendance updated successfully"
              : "✅ Attendance saved successfully"
          );
        }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="bg-gray-800 p-4 rounded-xl text-white space-y-4 border-2 border-cyan-200">
      <h2 className="text-yellow-200 text-sm lg:text-lg">Attendance Capture</h2>
      {/* {JSON.stringify(student, null, 2)}
      {t}{mode} */}
      {/* CAPTURE POINTS */}
      <div className="grid grid-cols-3 lg:grid-cols-7 gap-1">
        {capturePoints.map((p) => {
          const active = capturePoint === p;
          return (
            <button
              key={p}
              onClick={() => setCapturePoint(p)}
              className={`px-1 py-2 rounded-md text-xs lg:text-sm ${
                active ? "bg-teal-600" : "bg-gray-700"
              }`}
            >
              {t(p)}
            </button>
          );
        })}
      </div>

      <div className="flex gap-2">
        <button
          onClick={() => setAttendanceMode("IN")}
          className={`text-xs lg:text-sm w-20 lg:w-24 px-1 py-2 rounded ${
            attendanceMode === "IN"
              ? "bg-green-600"
              : "bg-gray-700"
          }`}
        >
          IN
        </button>

        <button
          onClick={() => setAttendanceMode("OUT")}
          className={`text-xs lg:text-sm w-20 lg:w-24 px-1 py-2 rounded ${
            attendanceMode === "OUT"
              ? "bg-orange-600"
              : "bg-gray-700"
          }`}
        >
          OUT
        </button>
      </div>

      {/* QR + LOCATION */}
      <div className="flex gap-2 flex-wrap">
        <button
          disabled={!!deviceLocation || !!showQR || isGeneralAttendance}
          onClick={() => setShowQR(true)}
          className={`text-xs lg:text-sm w-32 lg:w-40 px-1 py-2 rounded ${
            showQR
              ? "bg-gray-600 opacity-50 cursor-not-allowed"
              : "bg-blue-600"
          }`}
        >
          Scan QR
        </button>
        <button
          disabled={!!deviceLocation || !!showQR || isGeneralAttendance}
          onClick={handleLocationCapture}
          className={`text-xs lg:text-sm w-32 lg:w-40 px-1 py-2 rounded ${
            deviceLocation
              ? "bg-gray-600 opacity-50 cursor-not-allowed"
              : "bg-purple-600"
          }`}
        >
          Capture Location
        </button>
        <button
          disabled={!!deviceLocation || !!showQR || isGeneralAttendance}
          onClick={handleGeneralAttendance}
          className={`text-xs lg:text-sm w-40 lg:w-48 px-1 py-2 rounded ${
            isGeneralAttendance
              ? "bg-gray-600 opacity-50 cursor-not-allowed"
              : "bg-purple-600"
          }`}
        >
          General
        </button>
      </div>

      {/* QR MODAL */}
      {showQR && (
        <div className="mt-3">
          <HAFHQRScanner onScan={handleQRScan} />
        </div>
      )}

      {/* LOCATION STATUS */}
      {deviceLocation && (
        <div className="text-xs text-gray-300">
          📍 {deviceLocation.lat}, {deviceLocation.lng}
        </div>
      )}

      {/* REMARKS (single line input as requested) */}
      <input
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
        placeholder="Remarks"
        className="w-full p-2 bg-gray-700 rounded text-sm"
      />

      {/* FINAL SAVE */}
      <button
        disabled={
          isCaptureDisabled ||
          isSaving ||
          saveSuccess
        }
        onClick={handleCaptureAttendance}
        className={`lg:w-48 px-2 py-2 rounded text-xs lg:text-sm ${
          isCaptureDisabled || isSaving || saveSuccess
            ? "bg-gray-600 opacity-50 cursor-not-allowed"
            : "bg-teal-600 hover:bg-teal-500"
        }`}
      >
        {
          isSaving
            ? (isUpdateRecord? "Updating" : "Saving...")
            : saveSuccess
            ? (isUpdateRecord ? " Attendance Updated" : "Attendance Saved")
            : (isUpdateRecord ? "Update Attendance" : "Save Attendance")
        }
      </button>

      {saveMessage && (
        <div className="text-green-400 text-sm mt-2">
          {saveMessage}
        </div>
      )}
    </div>
  );
};

export default HAFHAttendanceCapture;